import { ReactNode } from 'react';
import { clsx } from 'clsx';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: boolean;
  as?: 'div' | 'section' | 'article';
}

export const Card = ({ children, className = '', padding = true, as: Component = 'div' }: CardProps) => {
  return (
    <Component className={clsx('card', padding && 'p-6', className)}>
      {children}
    </Component>
  );
};

export const CardHeader = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <div className={clsx('mb-4 pb-4 border-b border-border-subtle', className)}>
    {children}
  </div>
);

export const CardTitle = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <h2 className={clsx('text-lg font-semibold text-content-primary', className)}>
    {children}
  </h2>
);

export const CardDescription = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <p className={clsx('text-sm text-content-secondary', className)}>
    {children}
  </p>
);

export const CardContent = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <div className={className}>{children}</div>
);
